import { api, createCancelTokenHandler } from "../@vodea/services";

const endPoint = () => window._env_.REACT_APP_PASSPORT_END_POINT;

const Repository = {
  all: function (params: any = null) {
    return api.get(`${endPoint()}/api/admin/booking`, {
      params,
      cancelToken:
        cancelTokenHandlerObject[this.all.name].handleRequestCancellation()
          .token,
    });
  },
  show: function (id: number | string, params: any = null) {
    return api.get(`${endPoint()}/api/admin/booking/${id}`, {
      params,
      cancelToken:
        cancelTokenHandlerObject[this.show.name].handleRequestCancellation()
          .token,
    });
  },
  select: function (params: any = null) {
    return api.get(`${endPoint()}/api/select/booking`, {
      params,
      cancelToken:
        cancelTokenHandlerObject[this.select.name].handleRequestCancellation()
          .token,
    });
  },
  create: function (payload: any, params: any = null) {
    return api.post(`${endPoint()}/api/admin/booking`, payload, {
      params,
      cancelToken:
        cancelTokenHandlerObject[this.create.name].handleRequestCancellation()
          .token,
    });
  },
  update: function (id: number | string, payload: any, params: any = null) {
    return api.put(`${endPoint()}/api/admin/booking/${id}`, payload, {
      params,
      cancelToken:
        cancelTokenHandlerObject[this.update.name].handleRequestCancellation()
          .token,
    });
  },
  delete: function (id: number | string, params: any = null) {
    return api.delete(`${endPoint()}/api/admin/booking/${id}`, {
      params,
      cancelToken:
        cancelTokenHandlerObject[this.delete.name].handleRequestCancellation()
          .token,
    });
  },
  deleteMultiple: function (payload: any) {
    return api.post(`${endPoint()}/api/admin/delete-bookings`, payload, {
      cancelToken:
        cancelTokenHandlerObject[this.create.name].handleRequestCancellation()
          .token,
    });
  },
  saveNotes: function (id: number | string, payload: any, params: any = null) {
    return api.post(
      `${endPoint()}/api/admin/booking/${id}/save-notes`,
      payload,
      {
        params,
        cancelToken:
          cancelTokenHandlerObject[this.update.name].handleRequestCancellation()
            .token,
      }
    );
  },
  startSession: function (
    id: number | string,
    payload: any = null,
    params: any = null
  ) {
    return api.post(
      `${endPoint()}/api/admin/booking/${id}/start-session`,
      payload,
      {
        params,
        cancelToken:
          cancelTokenHandlerObject[
            this.startSession.name
          ].handleRequestCancellation().token,
      }
    );
  },
  endSession: function (
    id: number | string,
    payload: any = null,
    params: any = null
  ) {
    return api.post(
      `${endPoint()}/api/admin/booking/${id}/end-session`,
      payload,
      {
        params,
        cancelToken:
          cancelTokenHandlerObject[
            this.endSession.name
          ].handleRequestCancellation().token,
      }
    );
  },
  confirmPayment: function (
    id: number | string,
    payload: any = null,
    params: any = null
  ) {
    return api.post(`${endPoint()}/api/admin/booking/${id}/confirm-payment`, payload, {
      params,
      cancelToken:
        cancelTokenHandlerObject[
          this.confirmPayment.name
        ].handleRequestCancellation().token,
    });
  },
  markExpiredPayment: function (
    id: number | string,
    payload: any = null,
    params: any = null
  ) {
    return api.post(`${endPoint()}/api/admin/booking/${id}/mark-expired-payment`, payload, {
      params,
      cancelToken:
        cancelTokenHandlerObject[
          this.markExpiredPayment.name
        ].handleRequestCancellation().token,
    });
  },
};

const cancelTokenHandlerObject = createCancelTokenHandler(Repository);

export default Repository;
